import styled from 'styled-components';

export const Content = styled.main`
  padding: 0px 0px 0px 340px;
  min-height: 600px;

  @media (max-width: 1024px) {
    padding: 2.5rem 0 0 0;
    overflow-x: hidden;
  }
`;

export const LoadArea = styled.div`
  float: left;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const Align = styled.div`
  float: left;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 50px;
  flex-direction: column;

  @media (max-width: 1024px) {
    height: 40px;
  }

`;

export const Thumb = styled.div`
  float: left;
  width: 50px;
  overflow: hidden;
  border-radius: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};
  background: ${({ theme }) => theme.colors.LIGHT1};

  span {
    font-size: 22px;
    color: ${({ theme }) => theme.colors.TEXT1};
    font-weight: 700;
    text-transform: uppercase;
  }

  img {
    max-width: 90px;
    max-height: 90px;
    float: left;
    min-width: 60px;
    min-height: 60px;
  }

  @media (max-width: 1024px) {
    width: 40px;
    height: 40px;
     border-width: 2px;

    span {
      font-size: 16px;
    }
  }

`;

export const Reflection = styled.div`
  float: left;
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 20px;
  background: ${({ theme }) => theme.colors.LIGHT1};
  align-items: center;

  h1 {
    font-size: 12px;
    margin: 0px;
    padding: 0px;
    color: ${({ theme }) => theme.colors.TEXT1};
    text-transform: uppercase;
    font-weight: 700;
    margin: 0 20px 0 0;
  }

  main {
    display: flex;
    flex-direction: row;
    align-items: center;

    div {
      display: flex;
      flex-direction: row;
      background: ${({ theme }) => theme.colors.LIGHT1};
      border-radius: 6px;
      padding: 5px 10px 5px 5px;
      margin: 0 5px 0 0;
    }

    span {
      display: flex;
      flex-direction: column;

      strong {
        font-size: 8px;
        font-weight: 700;
        color: #ddd;
      }

      small {
        font-size: 10px;
        font-weight: 700;
        color: ${({ theme }) => theme.colors.TEXT1};
        text-decoration: underline;
      }
    }

    button {
      background: none;
      transition: all 0.5s ease;
      margin: 0 5px 0 0;

      &:hover {
        opacity: 0.5;
      }
    }
  }

  @media (max-width: 1024px) {
    padding: 20px 10px;

    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    main {
      padding: 0px;
      flex-direction: column;
      margin: 15px 0;
      align-items: flex-start;

      div {
        margin: 0px 0px 5px 0;
        padding: 5px 10px 5px 10px;
        width: 100%;

        &:last-child {
          margin: 0 0 0 0;
        }
      }
    }

    h1 {
      font-size: 10px;
    }
  }
`;

export const ClearFiltersBtn = styled.button`
  float: left;
  background: none;
  cursor: pointer;
  transition: all 0.5s ease;
  color: rgba(218, 59, 59, 1);
  font-weight: 700;
  margin: 0 0 0 20px;
  font-size: 10px;
  text-decoration: underline;

  &:hover {
    color: ${({ theme }) => theme.colors.TEXT1};
  }

  @media (max-width: 1024px) {
    margin: 0px;
  }
`;